import React, { Component } from 'react';
import $ from 'jquery';
import { findDOMNode } from 'react-dom';
import HorizontalFormField from "../HorizontalFormField";

export default class DateTimePickerField extends Component {


  componentDidMount() {
    const el = findDOMNode(this.field);

    $.fn.datetimepicker.defaults.icons = {
      time: 'fa fa-clock-o',
      date: 'fa fa-calendar',
      up: 'fa fa-chevron-up',
      down: 'fa fa-chevron-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      today: 'fa fa-dot-circle-o',
      clear: 'fa fa-trash',
      close: 'fa fa-times'
    };

    $(el).find('input').datetimepicker({
      showClose: true,
      showClear: true,
      keepOpen: false
    });
  }

  render() {
    return(
      <HorizontalFormField {...this.props} ref={(input) => { this.field = input}}/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/elements/form/fields/date/DateTimePickerField.js